import { Component, computed, inject, OnInit, signal} from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { NgClass } from '@angular/common';
import { UserService } from '../../../common/service/user.service';
import { ActivityLogService } from '../../../common/service/activity-log.service';
import { AuthService } from '../../../core/auth/auth.service';
import { CustomerService } from '../../../common/service/customer.service';
import { ActivityLog } from '../../../common/enum/activity-log.enum';
import { ActivityLogDto } from '../../../common/model/activity-log-dto';

@Component({
  selector: 'gate-customer-assignment-missing',
  standalone: true,
  imports: [TranslatePipe, ButtonModule, NgClass],
  templateUrl: './customer-assignment-missing.component.html'
})
export class CustomerAssignmentMissingComponent implements OnInit {
  private readonly userService = inject(UserService);
  private readonly authService = inject(AuthService);
  private readonly customerService = inject(CustomerService);
  private readonly activityLogService = inject(ActivityLogService);
  private readonly translateService = inject(TranslateService);

  countdown = 60;
  private countdownInterval?: number;
  copied = signal<boolean>(false);

  user = computed(() => this.userService.currentUser());

  ngOnInit(): void {
    const user = this.user();

    this.startCountdown();
    this.logActivity(user.subject);
  }

  private startCountdown(): void {
    this.countdownInterval = window.setInterval(() => {
      this.countdown--;

      if (this.countdown <= 0) {
        clearInterval(this.countdownInterval);
        this.redirectToFaq();
      }
    }, 1000);
  }

  private logActivity(userId?: string): void {
    if (!userId) return;

    const activity: ActivityLogDto = {
      userActivity: ActivityLog.UnassignedToAnyCustomer,
      userId,
      comment: 'User login attempted without assigned customer number.',
    };

    this.activityLogService.logActivity(activity);
  }
  public logout(){
    this.customerService.clearCustomerCache();
    this.authService.logout();
  }

  public redirectToFaq(): void {
    window.location.href = 'https://www.acp-gruppe.com/gate/faq';
  }
  public  copyTitle(): void {
     const titleText = this.translateService.instant('customerAssignmentMissingTitle', {
      firstName: this.user().familyName,
      lastName: this.user().givenName,
      email: this.user().email,
      userId: this.user().subject,
      provider:this.user().provider
    });
    navigator.clipboard.writeText(titleText);
    this.copied.set(true);
    setTimeout(() => this.copied.set(false), 3000);
  }
  
}
